import React from 'react'
import './howParticipate.scss'
import Title from '../../atoms/title/title'
import { navigate } from 'gatsby'
import useMediaQuery from '../../../utils/useMediaQuery'

const HowParticipate = () => {
  const isMobile = useMediaQuery()
  const stepsParticipate = [
    {
      title: 'Inicia sesión o regístrate',
      description: <p>
        <a onClick={() => navigate('/inicio-de-sesion')}> Inicia sesión,</a> o <a
        onClick={() => navigate('/registro')}>regístrate</a> para participar por tu kit
      </p>,
    },
    {
      title: 'Actualiza tus datos',
      description: <p>
        Así podremos contactarnos contigo para entregarte tu Kit Nosotras.
      </p>,
    },
    {
      title: 'Juega y aprende',
      description: <p>
        Juega y aprende… Diviértete con cada actividad y podrás llevarte un Kit Nosotras

      </p>,
    },
    {
      title: 'Más premios para ti',
      description: <p>Gana premios adicionales por realizar las actividades extras o compartirlas con tus amigas.</p>,
    },
  ]


  return (
    <section className='f-section-how-participate'>
      <div className='f-section-how-participate__wrapper'>

        <Title color='yellow' txt={['¿Cómo', 'participar en', 'la actividad?']} />

        <div className='f-section-how-participate__steps'>
          {stepsParticipate.map((item, index) => {
            return (
              <div key={`step-${index}`} className='f-section-how-participate__steps__step'>
                <span className='f-section-how-participate__steps__step-number'>{index + 1}</span>
                <div className='f-section-how-participate__steps__step-title'>
                  <h3>{item.title}</h3>
                </div>
                <div className='f-section-how-participate__steps__step-description'>
                  {item.description}
                </div>
              </div>

            )
          })}

        </div>

      </div>
    </section>
  )
}

export default HowParticipate
